import React from "react";
import { Button } from "@/components/ui/button";
import { Link as LinkIcon, X } from "lucide-react";

export default function OauthAccountsCard({ accounts, providers, onConnect, onDisconnect, t }) {
  return (
    <div className="bg-white border border-eh-border-soft rounded-2xl p-5" data-testid="social-accounts">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display text-lg flex items-center gap-2">
          <LinkIcon className="w-4 h-4 text-sol-gold" /> {t("social.connectedAccounts", { count: accounts.length })}
        </h3>
        <div className="flex gap-2">
          {providers.map((p) => (
            <Button
              key={p.id}
              size="sm"
              variant="outline"
              onClick={() => onConnect(p.id)}
              data-testid={`connect-${p.id}`}
              className="text-xs"
            >
              + {p.label}{!p.configured && <span className="ml-1 text-amber-500">{t("social.demo")}</span>}
            </Button>
          ))}
        </div>
      </div>
      {accounts.length === 0 ? (
        <p className="text-sm text-eh-muted">{t("social.noAccounts")}</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {accounts.map((a) => (
            <div key={a.id} data-testid={`account-${a.id}`} className="flex items-center justify-between bg-eh-cream/30 rounded-xl p-3">
              <div>
                <div className="text-sm font-medium text-eh-ink capitalize">{a.provider_label || a.provider}</div>
                <div className="text-xs text-eh-muted">{a.account_name}{a.demo_mode && ` ${t("social.demoParen")}`}</div>
              </div>
              <button onClick={() => onDisconnect(a.id)} className="text-rose-500 hover:bg-rose-50 p-1 rounded">
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
